import { MultiSelect } from 'src/design/atoms/MultiSelect';
import React from 'react';
import { OrganizationRoleDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';

export interface IRoleSelectorV2Props {
  onChange: (role: OrganizationRoleDto[]) => void;
  initialValue?: OrganizationRoleDto[];
  placeholder?: string;
  value: OrganizationRoleDto[];
}

/** @registry Select dropdown of roles (V2 API). */
export const RoleSelectorV2: React.FC<IRoleSelectorV2Props> = ({
  onChange,
  initialValue = [],
  placeholder = 'Select user roles...',
}) => {
  const { roles } = useOrganization();
  const [selected, setSelected] =
    React.useState<OrganizationRoleDto[]>(initialValue);
  React.useEffect(() => {
    onChange(selected);
  }, [selected]);

  // Transform rolesV2 data to  expected format
  const data = React.useMemo(() => {
    return roles.map((role) => ({
      value: String(role.id),
      label: role.name,
    }));
  }, [roles]);

  // Get the current value as an array of string IDs for Mantine
  const selectedValue = React.useMemo(() => {
    return selected.map((role) => String(role.id));
  }, [selected]);

  // Handle Mantine MultiSelect onChange - receives array of string values, need to find the full objects
  const handleChange = (selectedValues: string[]) => {
    const selectedRoles = selectedValues
      .map((value) => roles.find((role) => String(role.id) === value))
      .filter((role): role is OrganizationRoleDto => role !== undefined);
    setSelected(selectedRoles);
  };

  return (
    <MultiSelect
      placeholder={placeholder}
      data={data}
      value={selectedValue}
      onChange={handleChange}
      searchable
      clearable
    />
  );
};
